import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

Vue.config.productionTip = false


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'L1jwbFNnXQ9yZ7LWtAgUcQ2wC5keEmbz'
})

Vue.use(ElementUI)

//侧滑菜单
import DrawerLayout from 'vue-drawer-layout'

Vue.use(DrawerLayout)

// 定义全局的过滤器
Vue.filter('NumFormat', function (value) {
  var intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
  return intPartFormat
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
